export const CRUD_TYPE_READ = 'CRUD_TYPE_READ';
export const CRUD_TYPE_NEW = 'CRUD_TYPE_NEW';
export const CRUD_TYPE_UPDATE = 'CRUD_TYPE_UPDATE';
export const CRUD_TYPE_DELETE = 'CRUD_TYPE_DELETE';
